import Logo from './logo.svg'
import PrintLogo from './print-logo.svg'
import CoverImage from './report_cover.jpg'
import { HomePage } from './HomePage'
import { SignupPage } from './SignupPage'
import { PrivacyPage } from './PrivacyPage'
import { TermsPage } from './TermsPage'
import { ValuesPage } from './ValuesPage'
import { ThemesPage } from './ThemesPage'
import { TitlesPage } from './TitlesPage'
import { NextStepsPage } from './NextSteps'
import { themeData } from './themeData'
import Favicon from './favicon.ico'
import CongratsImage from './Congratulations_Gaming_1080x1350_Transparent.svg'

export default {
    favicon: Favicon,
    site: 'game',
    brandName: 'Job Passion',
    brandNameFull: 'Job Passion Assessment',
    displayDemographics: true,
    displayNextSteps: true,
    displayJobs: true,
    Logo: Logo,
    PrintLogo,
    CoverImage,
    HomePage,
    SignupPage,
    PrivacyPage,
    TermsPage,
    ValuesPage,
    ThemesPage,
    TitlesPage,
    NextStepsPage,
    themeData,
    CongratsImage
}